export default __webpack_public_path__ + "static/media/gcoin.dba864c2.png";